var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"mw-100 px-0"},[_c('RecProductionReport',{ref:"reportRef"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }